export const DOMAIN_REGEX = /^([0-9a-z-])+\.(([0-9a-z-]+\.)+)?([a-z])+$/i;

export default function domain(value = '') {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  if (DOMAIN_REGEX.test(value)) {
    return false;
  }

  return true;
}

domain.message = function message(value, options = {}) {
  return options.message || 'precisa ser um domínio válido';
};
